import { InjectionToken } from '@angular/core';

export interface HomePagePrimaryTabConfiguration {
  homePageBalanceTrendPrimaryTab: boolean;
}

export const HOME_PAGE_BALANCE_TREND_PRIMARY_TAB = new InjectionToken<HomePagePrimaryTabConfiguration>
('homePagePrimaryTabConfiguration');
